export default "<div>{{ GetWebhookType(id) }}</div>";